import { render } from "./PbannerView.vue?vue&type=template&id=a2bd26ae"
import script from "./PbannerView.vue?vue&type=script&lang=js"
export * from "./PbannerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__